import { edgelessTextToolbarExtension } from '@blocksuite/hive-block-edgeless-text';
import { frameToolbarExtension } from '@blocksuite/hive-block-frame';
import {
  brushToolbarExtension,
  highlighterToolbarExtension,
} from '@blocksuite/hive-gfx-brush';
import { connectorToolbarExtension } from '@blocksuite/hive-gfx-connector';
import { groupToolbarExtension } from '@blocksuite/hive-gfx-group';
import {
  mindmapToolbarExtension,
  shapeMindmapToolbarExtension,
} from '@blocksuite/hive-gfx-mindmap';
import { shapeToolbarExtension } from '@blocksuite/hive-gfx-shape';
import { textToolbarExtension } from '@blocksuite/hive-gfx-text';
import { ToolbarModuleExtension } from '@blocksuite/hive-shared/services';
import { BlockFlavourIdentifier } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';

import { builtinLockedToolbarConfig, builtinMiscToolbarConfig } from './misc';

export const EdgelessElementToolbarExtension: ExtensionType[] = [
  frameToolbarExtension,

  groupToolbarExtension,

  brushToolbarExtension,

  highlighterToolbarExtension,

  connectorToolbarExtension,

  shapeToolbarExtension,

  shapeMindmapToolbarExtension,

  mindmapToolbarExtension,

  textToolbarExtension,

  edgelessTextToolbarExtension,

  ToolbarModuleExtension({
    id: BlockFlavourIdentifier('hive:surface:*'),
    config: builtinMiscToolbarConfig,
  }),

  // Special Scenarios
  // Only display the `unlock` button when the selection includes a locked element.
  ToolbarModuleExtension({
    id: BlockFlavourIdentifier('hive:surface:locked'),
    config: builtinLockedToolbarConfig,
  }),
];
